import { apiSlice } from "app/api/apiSlice"

export const platformAdminApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['companies'],
    endpoints: builder => ({
        // GET Platform companies
        getAllCompanies: builder.query({
            query: () => 'platform/companies',
            keepUnusedDataFor: 5,
            providesTags: ['companies']
        }),
        // GET Platform Activity
        getPlatformActivty: builder.query({
            query: (lastDaysNumber) => ({
                url: '/platform/activity',
                params: { lastDaysNumber }
            }),
            keepUnusedDataFor: 5,
        }),
        // GET Platform Activity
        getPlatformStats: builder.query({
            query: () => '/platform/stats',
            keepUnusedDataFor: 5,
            providesTags: ['companies']
        }),
        // CREATE
        createCompany: builder.mutation({
            query: data => ({
                url: 'platform/newCompany',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['companies']
        }),
        // DELETE
        deleteCompany: builder.mutation({
            query: guid => ({
                url: 'platform/deleteCompany',
                method: 'DELETE',
                params: {
                    companyToDeleteGuid: guid
                }
            }),
            invalidatesTags: ['companies']
        }),
    })
})

export const {
    useGetAllCompaniesQuery,
    useGetPlatformActivtyQuery,
    useGetPlatformStatsQuery,
    useCreateCompanyMutation,
    useDeleteCompanyMutation
} = platformAdminApiSlice